import { VisibilityOutlined as VisibilityOutlinedIcon } from '@mui/icons-material';

const Visibility = (): JSX.Element => <VisibilityOutlinedIcon fontSize="inherit" />;

export default Visibility;
